import Blue from "~/core";

new Blue({
	name: 'Secondary Nav',
	selector: ".secondaryNav",
	setup(secondaryNav) {
    const items = [...secondaryNav.querySelectorAll('.secondaryNav__item')];
    const relations = [];

    items.forEach(container => {
      let trigger = container.querySelector('.secondaryNav__trigger')
      let content = container.querySelector('.secondaryNav__content')
      let config = {
        container,
        trigger,
        content,
        relations
      }
      relations.push(new this.$toggle(config));
    })
	}
});
